import React, { useCallback, useEffect, useRef, useState } from "react";
import defaultArtwork from "../../Assets/imgs/landingJazzcash/landingImg.webp";

import LandingJazzCash from "../pages/LandingJazzCash";
import {
  checkUserService,
  getArtworkService,
  getEnrichmentService,
  getPlanService,
} from "../../services/landingJCService";
import { useSearchParams } from "react-router-dom";
import { JAZZCASH_REDIRECT_URL } from "../../utils/config";

export const buildJazzcashRedirectUrl = (params: {
  msisdn: string;
  utm_source: string;
  planId: number;
}): string => {
  const url = new URL(JAZZCASH_REDIRECT_URL);
  url.searchParams.set("msisdn", params.msisdn);
  url.searchParams.set("utm_source", params.utm_source);
  url.searchParams.set("source", "CAMPAIGN");
  url.searchParams.set("plan_id", String(params.planId));
  return url.toString();
};

const LandingJazzCashScreen = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [msisdn, setMsisdn] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isPrivacyPolicyChecked, setIsPrivacyPolicyChecked] = useState(true);
  const [pricePoint, setPricePoint] = useState<string>("Rs.50/Weekly Inc.Tax");
  const [isLoadingArtwork, setIsLoadingArtwork] = useState(true);
  const [artworkUrl, setArtworkUrl] = useState<string>(defaultArtwork);
  const [subscibeDisabled, setSubscribeDisabled] = useState(true);
  const planIdRef = useRef(0);

  const plan_id = searchParams.get("plan_id") || "";
  const param_name = searchParams.get("utm_campaign") || "";

  useEffect(() => {
    runHeFlow();
    (async () => {
      await loadArtwork(param_name);
    })();
  }, []);

  const loadArtwork = async (paramName: string) => {
    try {
      setIsLoadingArtwork(true);
      if (!paramName) {
        setIsLoadingArtwork(false);
        setArtworkUrl(defaultArtwork);
        return;
      }
      const response = await getArtworkService(paramName);
      if (
        response &&
        response.status === 0 &&
        response.result &&
        response.result.url
      ) {
        setArtworkUrl(response.result.url);
      } else {
        setArtworkUrl(defaultArtwork);
      }
    } catch (error) {
      console.error("Error occurred while fetching artwork:", error);
      setArtworkUrl(defaultArtwork);
    } finally {
      setIsLoadingArtwork(false);
    }
  };

  const getPlanDetails = async (planId?: number, _msisdn?: string) => {
    try {
      const response = await getPlanService(planId);
      if (response.result) {
        const billingLabel = response.result.billingType
          ? response.result.billingType.charAt(0).toUpperCase() +
            response.result.billingType.slice(1).toLowerCase()
          : "Weekly";
        setPricePoint(`Rs.${response.result.price}/${billingLabel} Inc.Tax`);
        planIdRef.current = response.result.id;
        if (_msisdn) runCheckUserFlow(_msisdn);
        else setIsLoading(false);
      }
    } catch (error) {
      console.error("Error occurred while fetching plan details:", error);
    }
  };

  const runHeFlow = async () => {
    try {
      const response = await getEnrichmentService();
      if (response.success && response.result) {
        setMsisdn(response.result.slice(-10));
        await getPlanDetails(
          plan_id ? parseInt(plan_id) : undefined,
          response.result.slice(-10),
        );
      } else {
        await getPlanDetails(plan_id ? parseInt(plan_id) : undefined);
      }
    } catch (error) {
      console.error("Error occurred while fetching HE data:", error);
      await getPlanDetails(plan_id ? parseInt(plan_id) : undefined);
    }
  };

  const runCheckUserFlow = async (msisdn: string) => {
    try {
      const response = await checkUserService(msisdn);
      if (response.result === true) {
        setIsLoading(false);
        setErrorMessage("This number is already subscribed.");
      } else {
        setErrorMessage("");
        //redirect to jazzcash payment page
        redirectToPayment(msisdn);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error occurred while checking user:", error);
    }
  };

  const onMsisdnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const userInput = e.target.value;
    if (
      !userInput ||
      (userInput.length <= 10 && /^3\d{0,9}$/.test(userInput))
    ) {
      setErrorMessage("");
      setMsisdn(userInput);
    }
    setSubscribeDisabled(!(userInput.length === 10 && /^3/.test(userInput)));
  };

  const onPrivacyPolicyClick = () => {
    setIsPrivacyPolicyChecked(!isPrivacyPolicyChecked);
    setErrorMessage("");
  };

  const onContinueClick = () => {
    if (msisdn.length !== 10) {
      setErrorMessage("Please enter a valid Jazz Cash number.");
      return;
    } else if (!isPrivacyPolicyChecked) {
      setErrorMessage("Please agree to the Privacy Policy to continue.");
      return;
    } else {
      setIsLoading(true);
      runCheckUserFlow(msisdn);
    }
    setErrorMessage("");
  };

  const redirectToPayment = useCallback(
    (phone: string) => {
      const url = buildJazzcashRedirectUrl({
        msisdn: phone,
        utm_source: param_name,
        planId: planIdRef.current,
      });
      console.log("url::", url);
      window.location.replace(url);
    },
    [param_name],
  );

  return (
    <LandingJazzCash
      msisdn={msisdn}
      errorMessage={errorMessage}
      artworkUrl={artworkUrl}
      pricePoint={pricePoint}
      subscribeDisabled={subscibeDisabled}
      isLoadingArtwork={isLoadingArtwork}
      isLoading={isLoading}
      onMsisdnChange={onMsisdnChange}
      onPrivacyPolicyClick={onPrivacyPolicyClick}
      onContinueClick={onContinueClick}
      isPrivacyPolicyChecked={isPrivacyPolicyChecked}
    />
  );
};
export default LandingJazzCashScreen;
